module.exports = __webpack_public_path__ + "resources/kurfs/green-girl-on-laptop-sitting.svg";